import { Component } from '@angular/core';

@Component({
  selector: 'app-support-line',
  templateUrl: './support-line.component.html',
  styleUrls: ['./support-line.component.scss']
})
export class SupportLineComponent {

  constructor() { }

  callNow(){
    let redirectTelephone;
    redirectTelephone = `tel:#923`;
    window.location.href = redirectTelephone.replace("#", "%23");
  }
}
